"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var paragraph_1 = __importDefault(require("../../atoms/paragraph"));
var link_1 = __importDefault(require("../../atoms/link"));
exports.StyledParagraph = styled_1.default(paragraph_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  flex: 1 0 100%;\n  order: 1;\n  margin-top: ", ";\n  @media (min-width: 768px) {\n    margin-bottom: 0;\n  }\n"], ["\n  margin: 0;\n  flex: 1 0 100%;\n  order: 1;\n  margin-top: ", ";\n  @media (min-width: 768px) {\n    margin-bottom: 0;\n  }\n"])), tokens_1.spacing.medium);
var ArrowMore = styled_1.default.i(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  left: 2px;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6px;\n  border-color: transparent transparent transparent ", ";\n"], ["\n  position: relative;\n  left: 2px;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6px;\n  border-color: transparent transparent transparent ", ";\n"])), tokens_1.colors.link.default);
var StyledLink = styled_1.default(link_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &:hover ", " {\n    border-color: transparent transparent transparent ", ";\n  }\n"], ["\n  &:hover ", " {\n    border-color: transparent transparent transparent ", ";\n  }\n"])), ArrowMore, tokens_1.colors.link.defaultHover);
var Description = function (props) {
    return (React.createElement(exports.StyledParagraph, null,
        props.children.text,
        ' ',
        props.children.learnMore ? (React.createElement(StyledLink, { href: props.children.learnMore },
            "Learn more ",
            React.createElement(ArrowMore, null))) : null));
};
exports.default = Description;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=description.js.map